import * as Yup from 'yup';
import { PASSWORD_REG_EXP } from '../../components/auth/PasswordStrength/PasswordStrength';
import { Shape } from '../yup_types';
import { CHANGE_PASSWORD_FORM_FIELDS } from '../profile-settings/account-security/change-password-form';
import { FORGOT_PASSWORD_FORM_FIELDS } from '../forgot-password/forgot-password-form';

export enum CONFIRM_PASSWORD_FORM_FIELDS {
	EMAIL = 'email',
	TEMPORARY_PASSWORD = 'temporaryPassword',
	NEW_PASSWORD = 'newPassword',
	CONFIRM_PASSWORD = 'confirmPassword'
}

export enum CONFIRM_PASSWORD_FORM_FIELDS_NAMES {
	EMAIL = 'CONFIRM_PASSWORD.EMAIL',
	TEMPORARY_PASSWORD = 'CONFIRM_PASSWORD.TEMPORARY_PASSWORD',
	NEW_PASSWORD = 'CONFIRM_PASSWORD.NEW_PASSWORD',
	CONFIRM_PASSWORD = 'CONFIRM_PASSWORD.CONFIRM_NEW_PASSWORD'
}

type ConfirmPasswordSchemaType = {
	[key in CONFIRM_PASSWORD_FORM_FIELDS]: string;
};

export interface IConfirmPasswordFields {
	username?: string,
	temporaryPassword: string,
	newPassword: string
}

export interface IResetPasswordFields {
	username?: string,
	password: string
}

export const getConfirmPasswordSchema = (t): Yup.SchemaOf<ConfirmPasswordSchemaType> => Yup.object<Shape<ConfirmPasswordSchemaType>>().shape({
	[CONFIRM_PASSWORD_FORM_FIELDS.EMAIL]: Yup.string()
		.email(t('NEW_APPLICATION.VALIDATION.EMAIL_ERROR_TEXT'))
		.required(t('CONFIRM_PASSWORD.EMAIL_REQUIRED')),
	[CONFIRM_PASSWORD_FORM_FIELDS.TEMPORARY_PASSWORD]: Yup.string()
		.required(t('CONFIRM_PASSWORD.PASSWORD_REQUIRED')),
	[CONFIRM_PASSWORD_FORM_FIELDS.NEW_PASSWORD]: Yup.string()
		.matches(PASSWORD_REG_EXP.latter, t('CONFIRM_PASSWORD.NEW_PASSWORD_CONDITION1'))
		.matches(PASSWORD_REG_EXP.uppercase, t('CONFIRM_PASSWORD.NEW_PASSWORD_CONDITION2'))
		.matches(PASSWORD_REG_EXP.number, t('CONFIRM_PASSWORD.NEW_PASSWORD_CONDITION3'))
		.matches(PASSWORD_REG_EXP.symbol, t('CONFIRM_PASSWORD.NEW_PASSWORD_CONDITION4'))
		.matches(PASSWORD_REG_EXP.complete, t('CONFIRM_PASSWORD.NEW_PASSWORD_CONDITION5'))
		.min(8, t('CONFIRM_PASSWORD.NEW_PASSWORD_CONDITION6'))
		.max(50, t('CONFIRM_PASSWORD.NEW_PASSWORD_CONDITION7'))
		.required(t('CONFIRM_PASSWORD.NEW_PASSWORD_REQUIRED')),
	[CONFIRM_PASSWORD_FORM_FIELDS.CONFIRM_PASSWORD]: Yup.string()
		.oneOf([Yup.ref('newPassword'), null], t('CONFIRM_PASSWORD.PASSWORD_MATCH'))
		.required(t('CONFIRM_PASSWORD.CONFIRM_PASSWORD_REQUIRED')),
});

export const initialValues: ConfirmPasswordSchemaType = {
	[CONFIRM_PASSWORD_FORM_FIELDS.EMAIL]: '',
	[CONFIRM_PASSWORD_FORM_FIELDS.TEMPORARY_PASSWORD]: '',
	[CONFIRM_PASSWORD_FORM_FIELDS.NEW_PASSWORD]: '',
	[CONFIRM_PASSWORD_FORM_FIELDS.CONFIRM_PASSWORD]: '',
};

export const getFormattedConfirmPasswordFields = (formikValues: {[key: string]: string}): IConfirmPasswordFields => ({
	username: formikValues?.[CONFIRM_PASSWORD_FORM_FIELDS.EMAIL],
	temporaryPassword: formikValues?.[CONFIRM_PASSWORD_FORM_FIELDS.TEMPORARY_PASSWORD],
	newPassword: formikValues?.[CONFIRM_PASSWORD_FORM_FIELDS.NEW_PASSWORD]
});


export interface IConfirmInputs {
	key: CONFIRM_PASSWORD_FORM_FIELDS | CHANGE_PASSWORD_FORM_FIELDS | FORGOT_PASSWORD_FORM_FIELDS,
	fieldName: string,
	label?: string,
	placeholder: string,
	showPassword: boolean,
	additionalClass: string,
	setShowPassword?: (value: boolean) => void,
	isPasswordShown?: boolean,
	isPasswordStrengthShown?: boolean,
	type?: string,
	autoComplete: string,
}

export type ConfirmPasswordFieldsReturnType = {
	temporaryPassword: string,
	newPassword: string,
}

export type ResetPasswordFieldsReturnType = {
	password: string,
}

export const getFormattedConfirmPasswordFormFields = (formikValues: {[key: string]: string}): ConfirmPasswordFieldsReturnType => ({
	temporaryPassword: formikValues?.[CONFIRM_PASSWORD_FORM_FIELDS.TEMPORARY_PASSWORD],
	newPassword: formikValues?.[CONFIRM_PASSWORD_FORM_FIELDS.TEMPORARY_PASSWORD]
});

export const getFormattedResetPasswordFormFields = (formikValues: {[key: string]: string}): ResetPasswordFieldsReturnType => ({
	password: formikValues?.[CONFIRM_PASSWORD_FORM_FIELDS.CONFIRM_PASSWORD],
});
